<template>

	<div>

		<div v-if="parceiroConfig">

			<land-page-slider :parceiro="parceiro" ></land-page-slider>

			<section
				v-if="parceiroConfig.sessoes.about && parceiroConfig.sessoes.about.campos"
				:ref="'about'"
				class="section">
				<land-page-about ></land-page-about></section>

			<section
				v-if="parceiroConfig.sessoes.tutorial && parceiroConfig.sessoes.tutorial.campos"
				:ref="'tutorial'"
				class="section" >
				<land-page-tutorial></land-page-tutorial>
			</section>

			<section
				v-if="parceiroConfig.sessoes.partners && parceiroConfig.sessoes.partners.arquivos.length > 0"
				class="section" >
				<land-page-partner></land-page-partner>
			</section>

			<section
				v-if="parceiroConfig.sessoes.contact && parceiroConfig.sessoes.contact.campos"
				:ref="'contact'" >
				<land-page-contact></land-page-contact>
			</section>

			<land-page-footer></land-page-footer>

		</div>
	
	</div>

</template>

<script>
import Vue from "vue";
import Hotjar from "vue-hotjar";
import { mapState, mapMutations, mapActions } from "vuex";
import mixins from "@/mixins/mixins";

import LandPageHeader from "./components/LandPageHeader";
import LandPageSlider from "./components/LandPageSlider";
import LandPageAbout from "./components/LandPageAbout";
import LandPageTutorial from "./components/LandPageTutorial";
import LandPagePartner from "./components/LandPagePartner";
import LandPageContact from "./components/LandPageContact";
import LandPageFooter from "./components/LandPageFooter";

export default {
	name: "Home",

	components: {
		LandPageFooter,
		LandPageContact,
		LandPagePartner,
		LandPageTutorial,
		LandPageAbout,
		LandPageSlider,
		LandPageHeader
	},

	mixins: [mixins],

	computed: mapState({
		corPrimaria: (estado) => estado.corPrimaria,
		corSecundaria: (estado) => estado.corSecundaria
	}),

	created() {
		if (process.env.VUE_APP_SHOW_WHATSAPP_ALERT === "true") {
			this.CHANGE_MESSAGE_MODAL({
				show: true,
				title: "AVISO IMPORTANTE",
				message: `Nossos canais de WhatsApp (48) 3121-0250 e (48) 3121-0258 estão temporariamente indisponíveis.
				Enquanto isso, o atendimento por ligação segue normalmente pelo 0800 3121-003.`,
				styleMessage: "alert"
			});
		}

		let subdominio = process.env.VUE_APP_STANDARD_PARTNER;

		if (window.location.host.includes("portalexecutivarecuperacao")) {
			subdominio = "executiva";

		} else if (window.location.host.split(".").length > 2) {
			subdominio = window.location.host.split(".")[0] === "www" ? process.env.VUE_APP_STANDARD_PARTNER : window.location.host.split(".")[0];
		}

		if (subdominio) {

			this.SET_LOADING(true);
			this.SET_LOADING_MESSAGE("Carregando o portal");
			this.action_buscar_parceiro({ id: subdominio }).then((resposta) => {

				if (resposta) {
					this.SET_LOADING_MESSAGE("");
					this.SET_LOADING(false);

					let configParceiro = resposta.data.data;
					let header = configParceiro.sessoes.find((sessao) => sessao.nome === "header");
					let about = configParceiro.sessoes.find((sessao) => sessao.nome === "about");
					let partners = configParceiro.sessoes.find((sessao) => sessao.nome === "partners");
					let contact = configParceiro.sessoes.find((sessao) => sessao.nome === "contact");
					let tutorial = configParceiro.sessoes.find((sessao) => sessao.nome === "tutorial");
					let logoForBackgroundWhite = configParceiro.sessoes.find((sessao) => sessao.nome === "logoForBackgroundWhite");
					let customization = configParceiro.sessoes.find((sessao) => sessao.nome === "customization");
					let omniChannel = configParceiro.sessoes.find((sessao) => sessao.nome === "omniChannel");

					if (subdominio == "aquicob") {
						configParceiro.sessoes = {
							header: header,
							about: about,
							partners: partners,
							contact: contact,
							tutorial: tutorial,
							creditor: true,
							logoForBackgroundWhite: logoForBackgroundWhite,
							customization: customization,
							omniChannel: omniChannel
						};

					} else {
						configParceiro.sessoes = {
							header: header,
							about: about,
							partners: partners,
							contact: contact,
							tutorial: tutorial,
							creditor: null,
							logoForBackgroundWhite: logoForBackgroundWhite,
							customization: customization,
							omniChannel: omniChannel
						};
					}

					this.SET_PARCEIRO_CONFIG(configParceiro);

					if (configParceiro?.hotjar_id != null) {
						Vue.use(Hotjar, {
							id: configParceiro?.hotjar_id
						});
					}

					this.SET_COR_PRIMARIA({
						"--color": this.parceiroConfig.estilo.corPrimaria,
						"--hoverColor": this.parceiroConfig.estilo.corSecundaria
					});

					this.SET_COR_SECUNDARIA({
						"--color": this.parceiroConfig.estilo.corSecundaria,
						"--hoverColor": this.parceiroConfig.estilo.corPrimaria
					});

					this.CHANGE_MESSAGE_SNACKBAR("");

					if (this.parceiroConfig.identificador === "aqui") {
						document.title = "Negociar on-line";

						document.querySelector("link[rel='icon']").href = document.baseURI + "logo-negociar.png"
					}

				} else {
					this.SET_LOADING_MESSAGE("");
					this.SET_LOADING(false);
					this.CHANGE_MESSAGE_MODAL({
						show: true,
						title: "Atenção",
						message: `Subdomínio não encontrado!`,
						styleMessage: "danger"
					});
				}
			}).catch((_) => {
				this.SET_LOADING_MESSAGE("");
				this.SET_LOADING(false);
				this.CHANGE_MESSAGE_MODAL({
					show: true,
					title: "Atenção",
					message: `Subdomínio não encontrado!`,
					styleMessage: "danger"
				});
				this.$router.push({ name: "LandPageParceiro" });
			});
		}

		this.action_salvar_etapa({
			esn_fk_ets_codigo: 31,
			emp_codigo: this.parceiroConfig.emp_codigo,
			motivo_agendamento: "Página inicial",
			cpfCnpj: "12341234567"
		});
	},

	methods: {
		...mapActions(["action_buscar_parceiro"]),

		...mapMutations(["SET_PARCEIRO_CONFIG", "SET_COR_PRIMARIA", "SET_COR_SECUNDARIA"])
	}
};
</script>

<style scoped>
.section {
	padding-top: 60px;
	padding-bottom: 60px;
}
</style>
